import React, { useState } from 'react';

import '../styles/auth.css';

import { PasswordInputProps } from '../types/auth';

const EyeOffIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const EyeIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const PasswordToggleButton: React.FC<{
  showPassword: boolean;
  onClick: () => void;
}> = ({ showPassword, onClick }) => (
  <button
    type="button"
    className="password-toggle-btn"
    onClick={onClick}
    tabIndex={-1}
    aria-label={showPassword ? 'Hide password' : 'Show password'}
  >
    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
  </button>
);

const PasswordField: React.FC<{
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  disabled?: boolean;
  autoFocus?: boolean;
  showPassword: boolean;
}> = ({ value, onChange, placeholder, disabled, autoFocus, showPassword }) => (
  <input
    type={showPassword ? 'text' : 'password'}
    className="password-input"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    placeholder={placeholder}
    aria-label={placeholder}
    autoFocus={autoFocus}
    autoComplete="current-password"
  />
);

export const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChange,
  placeholder = 'Password',
  disabled,
  autoFocus,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleVisibility = () => setShowPassword((prev) => !prev);

  return (
    <div className="password-input-wrapper">
      <PasswordField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        showPassword={showPassword}
      />
      <PasswordToggleButton showPassword={showPassword} onClick={toggleVisibility} />
    </div>
  );
};
